import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { Parser } from "html-to-react";
import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { useParams } from "react-router-dom";
import { Context } from "../../context";
import classes from "./Project.module.css";
import ProjectBreadcrumb from "./ProjectBreadcrumb";
import ProjectDetailsGallery from "./ProjectDetailsGallery";
const url = "https://www.aroundweb.it/davidebalice.dev/data/projects.json";

const ProjectDetails = () => {
  const [projectData, setProjectData] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const { debug, lang } = useContext(Context);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };
  const [filteredData, setFilteredData] = useState([]);
  let params = useParams();
  let delay = 0;

  const getData = async () => {
    try {
      const response = await axios.get(url);
      const filtered = response.data.find((item) => item.slug === params.slug);
      setFilteredData(filtered);
      setProjectData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Container
        fluid
        className={`${classes.projectDetailBg} text-center pb-5 pt-5`}
      >
        <Container
          fluid
          className={`${classes.projectDetailContainer} text-center pb-5 pt-5`}
        >
          <ProjectBreadcrumb title={filteredData.title} />
          <div className="row">
            <div className="col-md-6">
              <div
                className={classes.projectImgDetail}
                style={{
                  background: `url("/assets/images/${filteredData.photo}.jpg")`,
                }}
              >
                {" "}
              </div>
            </div>
            <div className={`${classes.detailCol} col-md-6 text-left`}>
              <h1 className={`${classes.projectTitle} text-8 mb-4 fw-600`}>
                {filteredData.title}
              </h1>

              {filteredData.url && (
                <div className="row mb-4">
                  <div className={`${classes.iconBox} col-auto`}>
                    <FontAwesomeIcon
                      className={`${classes.icon} linkIcon`}
                      icon={faLink}
                      style={{ color: "#19a3ca" }}
                    />
                  </div>
                  <div className="col-auto">
                    <a
                      href={`https://${filteredData.url}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {filteredData.url}
                    </a>
                  </div>
                </div>
              )}
              {filteredData.url2 && (
                <div className="row mb-4">
                  <div className={`${classes.iconBox} col-auto`}>
                    <FontAwesomeIcon
                      className={`${classes.icon} linkIcon`}
                      icon={faLink}
                      style={{ color: "#19a3ca" }}
                    />
                  </div>
                  <div className="col-auto">
                    <a
                      href={`https://${filteredData.url2}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {filteredData.url2}
                    </a>
                  </div>
                </div>
              )}
              <p className={`${classes.description} mt-5`}>
                {lang === "en"
                  ? Parser().parse(filteredData.long_desc)
                  : Parser().parse(filteredData.long_desc_it)}
              </p>
            </div>
          </div>
        </Container>
      </Container>

      {filteredData.id === 4 && <>aaaaaaaaaaaaaaaaaa</>}
      {filteredData.id !== 4 && (
        <>
          <ProjectDetailsGallery
            showText
            type="frontend"
            data={filteredData.gallery_frontend}
            caption={filteredData.caption_frontend}
          />
          <ProjectDetailsGallery
            type="backend"
            data={filteredData.gallery_backend}
            caption={filteredData.caption_backend}
          />
        </>
      )}

      <div className={classes.projectLinea}></div>
      <script src="/vendor/jquery/jquery.min.js"></script>
      <script src="/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
      <script src="/js/theme.js"></script>
    </>
  );
};

export default ProjectDetails;
